/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Report_Reasons_LabelInputs */

const en_us2_exercise_sheet_report_reasons_label = /** @type {(inputs: Exercise_Sheet_Report_Reasons_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reason`)
};

const pt_br2_exercise_sheet_report_reasons_label = /** @type {(inputs: Exercise_Sheet_Report_Reasons_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivo`)
};

const es_419_exercise_sheet_report_reasons_label = /** @type {(inputs: Exercise_Sheet_Report_Reasons_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivo`)
};

const pt_pt2_exercise_sheet_report_reasons_label = /** @type {(inputs: Exercise_Sheet_Report_Reasons_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivo`)
};

const fr_fr2_exercise_sheet_report_reasons_label = /** @type {(inputs: Exercise_Sheet_Report_Reasons_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motif`)
};

const de_de2_exercise_sheet_report_reasons_label = /** @type {(inputs: Exercise_Sheet_Report_Reasons_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grund`)
};

const it_it2_exercise_sheet_report_reasons_label = /** @type {(inputs: Exercise_Sheet_Report_Reasons_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivo`)
};

/**
* | output |
* | --- |
* | "Reason" |
*
* @param {Exercise_Sheet_Report_Reasons_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_report_reasons_label = /** @type {((inputs?: Exercise_Sheet_Report_Reasons_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Report_Reasons_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_report_reasons_label(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_report_reasons_label(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_report_reasons_label(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_report_reasons_label(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_report_reasons_label(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_report_reasons_label(inputs)
	return en_us2_exercise_sheet_report_reasons_label(inputs)
});
export { exercise_sheet_report_reasons_label as "exercise-sheet.report_reasons_label" }